// extracted by mini-css-extract-plugin
module.exports = {"list":"ProductTabList_list__3-szz","card":"ProductTabList_card__KVvWW"};